import { basic, initTopbar } from './modules/layouts';

initTopbar();
basic();
